<template>
  <div>
    <el-card>
      <h3 class="title">成功提示</h3>
      <el-form label-position="left" ref="ruleForm" :rules="rules" :model="successData" :disabled="disabledFlag">
        <!-- <el-form-item
          label="图片标题"
          label-width="120px">
          <el-col :span="12">
            <el-input  maxlength="20" v-model.trim="successData.picTitle" placeholder="请输入图片标题"/>
          </el-col>
        </el-form-item> --> 
        <el-form-item
          label-width="120px"
          prop="picToken">
          <el-row slot="label">
            <span class="name">上传图片</span>
            <el-tooltip content="引导页步骤展示图片" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
          <el-col :span="12">
            <UploadPic @getData="getData" :picData="successData"/>
            <el-image
            v-if="successData.picUrl !== ''"
            style="width: 100px; height: 100px" 
            :src="successData.picUrl"
            :preview-src-list="[successData.picUrl]"></el-image>
          </el-col>
        </el-form-item>
        <el-form-item
          prop="picDesc"
          label-width="120px">
          <el-row slot="label">
            <span class="name">提示文字</span>
            <el-tooltip content="引导页步骤提示语" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
          <el-col :span="12">
            <el-input
            :autosize="{ minRows: 3, maxRows: 3}"
            v-model="successData.picDesc"
            :maxlength="255"
            type="textarea"
            placeholder="文字限制255个字符内"
            class="add1TextArea"/>
          </el-col>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import UploadPic from '@/components/categoryManager/uploadPic'
export default {
  components: {
    UploadPic
  },
  props: {
    successData: {
      type: Object
    },
    disabledFlag: {
      type: Boolean
    },
    allImgList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    const picVerify = (rule, value, callback) => {
      if (!this.successData.picToken) {
        callback(new Error('请选择图片'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        // picTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        picDesc: [{ required: true, message: '请输入提示文字', trigger: 'blur' }],
        picToken: [
          { required: true, validator: picVerify, trigger: 'change' }
        ]
      }
    } 
  },
  created () {
    // setTimeout(e => {
    //   this.getData(); // 测试
    // }, 1000)
  },
  methods: {
    getData (val) {
      // val = {
      //   fileKey: 'appGuide/img/20240428/28cb87974d5d4a54ad2e23fce26b93a3.png',
      //   fileUrl: "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/28cb87974d5d4a54ad2e23fce26b93a3.png?Expires=1714880488&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=ZXwaKWdTDwO%2B87NeIXrbNElgOI4%3D"
      // }

      let {fileKey: picToken, fileUrl: picUrl, name} = val;
      this.successData.guideStepImageDtoList = [{
        picToken,
        picName: picUrl,
        picUrl
      }]
      this.successData.picToken = val.fileKey
      this.successData.picUrl = val.fileUrl
      this.allImgList.push(val.fileKey);
      debugger;
      this.$forceUpdate();
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-form-item__label{
  display:flex;
  align-items: center !important;
}
.el-card{
  padding: 14px;
}
/deep/ .el-card__body{
  padding: 0;
}
.title{
  width: 10%;
  padding: 5px 5px 5px 0;
  display: inline-block;
  margin-bottom: 10px;
  border-bottom: 1px solid #e6e2e2;
}
.el-col-12{
    flex-direction: column;
  }
  .el-image{
    margin-top: 20px;
  }
</style>
